export const LAST_VISITED_PAGE_V2_COOKIE_KEY = 'lastVisitedPageV2';

export const BASE_FUNNEL_NAME = 'Kegel_BL';

export interface LastVisitedPageV2CookieModel {
  funnelName: string
  lastRoute: string
  query: Record<string, any>
}

export function resolveFunnelName(
  funnelId: string | undefined,
  baseURL: string | undefined,
  queryFunnel?: unknown,
): string {
  const funnelFromQuery = Array.isArray(queryFunnel) ? queryFunnel[0] : queryFunnel;
  const funnelFromContext = funnelId && funnelId !== 'baseline' ? funnelId : undefined;
  const baseFunnel = baseURL?.split('/')?.find(Boolean);

  return String(funnelFromQuery || funnelFromContext || baseFunnel || BASE_FUNNEL_NAME);
}
